import { Component, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'

export default class ResortPricingRowUnavailable extends Component {
  render() {
    const { room } = this.props
    return (
      <div className='resort-pricing-row unavailable'>
        <div className='resort-pricing__rooms'>
          <h4 className='room-name'>{ room.title }</h4>
          <div className='room-info'>
            <div className='room-info-wrapper'>
              <a className='room-more-info' onClick={() => this.props.openRoomPopup(room)}>
                <FormattedMessage id='show_room_info' defaultMessage='Show room information' />
                <i className='font-icons right-arrow-icon' />
              </a>
            </div>
          </div>
        </div>
        <div className='resort-pricing__meal-plan' />
        <div className='resort-pricing__price'>
          <p className='pricing-error'>
            {
              room.exceptionMessage || room.error
                ? <Fragment>{room.exceptionMessage || room.error}</Fragment>
                : <FormattedMessage id='not_available_for_number_of_guests' defaultMessage='This room is not available for your selected number of guests' />
            }
          </p>
        </div>
      </div>
    )
  }
}
